/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UnreadCount
 */
export interface UnreadCount {
    /**
     * 
     * @type {string}
     * @memberof UnreadCount
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof UnreadCount
     */
    count?: number;
}

/**
 * Check if a given object implements the UnreadCount interface.
 */
export function instanceOfUnreadCount(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UnreadCountFromJSON(json: any): UnreadCount {
    return UnreadCountFromJSONTyped(json, false);
}

export function UnreadCountFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnreadCount {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'count': !exists(json, 'count') ? undefined : json['count'],
    };
}

export function UnreadCountToJSON(value?: UnreadCount | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'count': value.count,
    };
}

